import { Link } from "react-router-dom";
import { useMemo, useRef, useState, useEffect } from "react";

import bloom220Img from "../assets/images/BLOOM220SOLITO.png";
import bloom250Img from "../assets/images/BLOOM250SOLITO.png";

// Tus 6 tarjetas (1.png … 6.png)
import card1 from "../assets/images/1.png";
import card2 from "../assets/images/2.png";
import card3 from "../assets/images/3.png";
import card4 from "../assets/images/4.png";
import card5 from "../assets/images/5.png";
import card6 from "../assets/images/6.png";

const WHATSAPP_NUMBER = "51994692096";

function waLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}



function Modal({ open, onClose, item }) {
  // Cerrar con ESC
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !item) return null;

  return (
    <div className="fixed inset-0 z-[100]">
      {/* Backdrop */}
      <button
        onClick={onClose}
        className="absolute inset-0 bg-black/35 backdrop-blur-[2px]"
        aria-label="Cerrar"
      />

      {/* Panel */}
      <div className="absolute left-1/2 top-1/2 w-[min(980px,92vw)] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[32px] bg-white shadow-[0_60px_140px_rgba(0,0,0,0.30)]">
        {/* Header imagen */}
        <div className="relative">
          <div className="h-[280px] w-full bg-slate-100 sm:h-[320px]">
            <img
              src={item.image}
              alt={item.title}
              className="h-full w-full object-cover"
              draggable="false"
            />
          </div>

          {/* Botón X */}
          <button
            onClick={onClose}
            className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-full border border-black/10 bg-white/80 text-slate-900 shadow-sm backdrop-blur hover:bg-white"
            aria-label="Cerrar"
            title="Cerrar"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="px-7 pb-7 pt-6 sm:px-10 sm:pb-10">
          <p className="text-[12px] font-semibold tracking-wide text-slate-500">
            {item.kicker}
          </p>
          <h3 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {item.title}
          </h3>
          <p className="mt-3 max-w-3xl text-[15px] leading-relaxed text-slate-600">
            {item.description}
          </p>

          <div className="mt-6 rounded-[26px] border border-black/10 bg-slate-50 p-6 sm:p-7">
            <ul className="space-y-3 text-[15px] text-slate-700">
              {item.bullets.map((b) => (
                <li key={b} className="flex gap-3">
                  <span className="mt-[8px] h-2 w-2 flex-none rounded-full bg-slate-900" />
                  <span className="leading-relaxed">{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={waLink(item.waMessage)}
                target="_blank"
                rel="noreferrer"
                className="rounded-full bg-slate-900 px-6 py-3 text-[14px] font-medium text-white hover:bg-black transition"
              >
                Consultar por WhatsApp
              </a>

              <button
                onClick={onClose}
                className="rounded-full border border-black/10 bg-white px-6 py-3 text-[14px] font-medium text-slate-900 hover:bg-slate-50 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Gelatinas() {
  const scrollRef = useRef(null);
  const [openId, setOpenId] = useState(null);

  const items = useMemo(
    () => [
      {
        id: "card-1",
        image: card1,
        kicker: "Ingrediente natural",
        title: "Proteína de origen natural, segura y confiable",
        description:
          "Una base funcional para formulaciones que buscan rendimiento y consistencia.",
        bullets: [
          "Origen natural con perfil funcional para múltiples aplicaciones.",
          "Aporta estructura, estabilidad y una experiencia final agradable.",
          "Ideal cuando necesitas resultados repetibles en cada preparación.",
        ],
        waMessage: "Hola, quiero más información sobre Gelico (Ingrediente natural).",
      },
      {
        id: "card-2",
        image: card2,
        kicker: "Nutrición",
        title: "Proteína funcional de alta calidad",
        description:
          "Pensada para apoyar textura y desempeño sin complicar tu receta ni tu proceso.",
        bullets: [
          "Ingrediente versátil para formulaciones con enfoque en textura y cuerpo.",
          "Se integra fácilmente en distintas preparaciones.",
          "Ayuda a obtener una calidad final más uniforme.",
        ],
        waMessage: "Hola, quiero más información sobre Gelico (Nutrición).",
      },
      {
        id: "card-3",
        image: card3,
        kicker: "Bloom",
        title: "La fuerza que define la textura",
        description:
          "El Bloom está relacionado con la firmeza del gel y el tipo de estructura que logras.",
        bullets: [
          "Más Bloom → gel más firme y con mayor estructura.",
          "Bloom 220: balance entre firmeza y elasticidad.",
          "Bloom 250: firmeza superior para estructura más marcada.",
        ],
        waMessage: "Hola, quiero más información sobre Gelico (Bloom).",
      },
      {
        id: "card-4",
        image: card4,
        kicker: "Textura y viscosidad",
        title: "Control total del proceso",
        description:
          "Cuando la textura importa, el control del gel y su comportamiento hace la diferencia.",
        bullets: [
          "Permite ajustar la sensación final (cuerpo, elasticidad, firmeza).",
          "Mejor control del comportamiento del gel en tu receta.",
          "Consistencia para mantener tu estándar de producto.",
        ],
        waMessage:
          "Hola, quiero más información sobre Gelico (Textura y viscosidad).",
      },
      {
        id: "card-5",
        image: card5,
        kicker: "Estabilidad térmica",
        title: "Se adapta a tu proceso",
        description:
          "Un desempeño más estable frente a cambios de temperatura durante preparación y reposo.",
        bullets: [
          "Comportamiento confiable frente a variaciones de temperatura del proceso.",
          "Aporta estabilidad durante preparación, reposo y almacenamiento.",
          "Mejor control del gel y de la textura final.",
        ],
        waMessage: "Hola, quiero más información sobre Gelico (Estabilidad térmica).",
      },
      {
        id: "card-6",
        image: card6,
        kicker: "Aplicaciones",
        title: "Un ingrediente, múltiples usos",
        description:
          "Desde alimentos hasta formulaciones que buscan estructura y estabilidad.",
        bullets: [
          "Aporta estructura y estabilidad en diversas aplicaciones.",
          "Ayuda a mejorar consistencia y presentación final.",
          "Versátil para diferentes recetas y usos.",
        ],
        waMessage: "Hola, quiero más información sobre Gelico (Aplicaciones).",
      },
    ],
    []
  );

  const activeItem = useMemo(() => items.find((x) => x.id === openId), [items, openId]);

  function scrollByCards(dir) {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 360; // paso tipo Apple
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  }

  return (
    <main className="bg-white">
      {/* Hero minimal tipo Apple */}
      <section className="border-b border-black/5">
        <div className="mx-auto max-w-6xl px-6 py-14 md:py-18">
          <div className="text-center">
            <h1 className="mt-3 text-5xl md:text-6xl font-semibold tracking-tight text-slate-900">
              Gelatina
            </h1>
          </div>
        </div>
      </section>

      {/* 2 cards grandes Bloom */}
      <section className="mx-auto max-w-6xl px-6 py-10 md:py-14">
        <div className="grid gap-6 md:grid-cols-2">
          {/* Bloom 220 */}
          <div className="group overflow-hidden rounded-[28px] border border-black/5 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.06)]">
            <div className="relative">
              <div className="absolute left-5 top-5 z-10">
                <span className="inline-flex items-center rounded-full bg-white/80 px-3 py-1 text-[12px] font-semibold text-slate-800 backdrop-blur border border-black/10">
                  Nuevo • Bloom 220
                </span>
              </div>

              <div className="aspect-[16/10] w-full bg-slate-50">
                <img
                  src={bloom220Img}
                  alt="Gelatina Bloom 220"
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.02]"
                  draggable="false"
                />
              </div>
            </div>

            <div className="p-6 md:p-7">
              <p className="text-sm font-semibold text-slate-900">Bloom 220</p>
              <p className="mt-1 text-sm text-slate-600">
                Equilibrio perfecto entre firmeza y elasticidad.
              </p>

              <div className="mt-5 flex flex-wrap gap-3">
                <Link
                  to="/gelatinas/bloom-220"
                  className="rounded-full bg-blue-600 px-5 py-2.5 text-[14px] font-medium text-white hover:bg-blue-700 transition"
                >
                  Más información
                </Link>

                <a
                  href={waLink(
                    "Hola, deseo cotizar Gelatina Bloom 220. Cantidad: __ kg. Mesh: __. Ciudad: __."
                  )}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full border border-blue-600/40 bg-white px-5 py-2.5 text-[14px] font-medium text-blue-700 hover:bg-blue-50 transition"
                >
                  Comprar →
                </a>
              </div>
            </div>
          </div>

          {/* Bloom 250 */}
          <div className="group overflow-hidden rounded-[28px] border border-black/5 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.06)]">
            <div className="relative">
              <div className="absolute left-5 top-5 z-10">
                <span className="inline-flex items-center rounded-full bg-white/80 px-3 py-1 text-[12px] font-semibold text-slate-800 backdrop-blur border border-black/10">
                  Nuevo • Bloom 250
                </span>
              </div>

              <div className="aspect-[16/10] w-full bg-slate-50">
                <img
                  src={bloom250Img}
                  alt="Gelatina Bloom 250"
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.02]"
                  draggable="false"
                />
              </div>
            </div>

            <div className="p-6 md:p-7">
              <p className="text-sm font-semibold text-slate-900">Bloom 250</p>
              <p className="mt-1 text-sm text-slate-600">
                Firmeza superior y estabilidad para procesos exigentes.
              </p>

              <div className="mt-5 flex flex-wrap gap-3">
                <Link
                  to="/gelatinas/bloom-250"
                  className="rounded-full bg-blue-600 px-5 py-2.5 text-[14px] font-medium text-white hover:bg-blue-700 transition"
                >
                  Más información
                </Link>

                <a
                  href={waLink(
                    "Hola, deseo cotizar Gelatina Bloom 250. Cantidad: __ kg. Mesh: __. Ciudad: __."
                  )}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full border border-blue-600/40 bg-white px-5 py-2.5 text-[14px] font-medium text-blue-700 hover:bg-blue-50 transition"
                >
                  Comprar →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Carrusel Apple-like con 6 tarjetas + flechas */}
      <section className="mx-auto max-w-6xl px-6 pb-16">
        <div className="flex items-end justify-between gap-4">
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-slate-900">
            Descubre la Gelatina Gelico.
          </h2>

          <div className="flex gap-2">
            <button
              onClick={() => scrollByCards(-1)}
              className="grid h-10 w-10 place-items-center rounded-full border border-black/10 bg-white text-slate-900 shadow-sm hover:bg-slate-50"
              aria-label="Anterior"
              title="Anterior"
            >
              ‹
            </button>
            <button
              onClick={() => scrollByCards(1)}
              className="grid h-10 w-10 place-items-center rounded-full border border-black/10 bg-white text-slate-900 shadow-sm hover:bg-slate-50"
              aria-label="Siguiente"
              title="Siguiente"
            >
              ›
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="no-scrollbar mt-8 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-3"
        >
          {items.map((it) => (
            <button
              key={it.id}
              onClick={() => setOpenId(it.id)}
              className="group relative w-[300px] flex-none snap-start overflow-hidden rounded-[34px] bg-slate-100 shadow-[0_30px_80px_rgba(0,0,0,0.10)] transition hover:shadow-[0_40px_110px_rgba(0,0,0,0.14)] active:scale-[0.99] sm:w-[340px]"
              aria-label={it.title}
              title={it.title}
            >
              <div className="aspect-[9/16] w-[320px] sm:w-[360px] lg:w-[380px] bg-white">
                <img
                  src={it.image}
                  alt={it.title}
                  className="h-full w-full object-contain"
                  draggable="false"
                />
              </div>

            </button>
          ))}
        </div>
      </section>

      <Modal open={!!openId} onClose={() => setOpenId(null)} item={activeItem} />
    </main>
  );
}
